<template>
    <el-menu
            :router="true"
            class="el-menu-demo"
            :mode="mmode"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
    >
        <el-menu-item index="/">
            <i class="el-icon-pie-chart"></i>
        </el-menu-item>

        <el-menu-item index="/cars">
            Автомобили
        </el-menu-item>

        <el-menu-item index="/tuning">
            Тюнинг/Экстерьер
        </el-menu-item>

        <el-menu-item index="/" @click="logout('/login')">
            <i class="el-icon-right"></i>
        </el-menu-item>
    </el-menu>
</template>

<script>
import {mapActions} from 'vuex'

export default {
    name: "MenuTop",
    props: ['isOpen'],
    data() {
        return {
            mmode: 'horizontal',
        }
    },
    methods: {
        ...mapActions('auth', ['logout']),
    }
}
</script>

<style lang="scss" scoped>
.el-menu-demo {
  position: fixed;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  i {
    color: #fff;
  }
}

@media screen and (max-width: 800px) {
  .el-menu-demo {
    position: fixed;
    top: 60px;
  }
}
</style>
